<template>
  <v-dialog
    v-model="dialogProps"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
    :width="width || 1200"
  >
    <v-row no-gutters class="dialog-container">
      <v-col cols="12" :md="imageOnly ? 12 : 7">
        <v-img
          :src="image"
          :width="imageOnly ? '100%' : mdAndUp ? 600 : 300"
          :height="imageHeight || undefined"
          :class="mdAndUp ? '' : 'mt-4'"
          :contain="contain"
        />
      </v-col>
      <v-col
        v-if="!imageOnly"
        cols="12"
        md="4"
        class="pr-4 d-flex flex-column"
        :class="orientation"
      >
        <h3 class="primary--text mb-4">{{ title }}</h3>
        <span>{{ subtitle }}</span>
      </v-col>
      <v-btn
        icon
        class="close-button"
        @click="$emit('close')"
        aria-label="Close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-row>
  </v-dialog>
</template>

<script>
import displayHelpers from "@/mixins/breakpoints.mixins";
export default {
  name: "ImageExample",
  mixins: [displayHelpers],
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    orientation: {
      type: String,
      default: "",
    },
    contain: {
      type: Boolean,
      default: false,
    },
    imageHeight: {
      type: [String, Number],
      default: "",
    },
    imageOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogProps() {
      return this.dialog;
    },
  },
};
</script>

<style scoped>
.dialog-container {
  background-color: #e9e8ed;
  padding: 24px;
  position: relative;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 100;
}
</style>
